import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as saveAs from 'file-saver';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { AllProductService } from 'src/app/services/shared/product-settings/all-products.service';
import { CategoryService } from 'src/app/services/shared/product-settings/category.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss']
})
export class ImportComponent {
    fileName: string = '';
    invalidFileType = false;
    fileType = '';
    oemId : string = ''; 
  categories: any[] = [];
  
    constructor(
      private dialogRef: MatDialogRef<ImportComponent>, 
      private sweetAlertService: SweetAlertService,
      private allProductService: AllProductService,
      private localStorageService: LocalStorageService,
      private categoryService: CategoryService,
      @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit(): void {
      const id = localStorage.getItem('oemId');
      if(id !== null && id !== undefined && id !== '') {
        this.oemId = id;
       
        
      }
      this.getChildCategories();
    }
  
    acceptedFileFormats = ['text/csv']

    onFileSelected(event: any): void {
      const file: File = event.target.files[0];
      if (file) {
        this.invalidFileType = false
        if (this.acceptedFileFormats.indexOf(file.type) !== -1) {
          this.fileName = file.name;
          this.allProductService.importFile(file, this.oemId).subscribe(
            (response) => {
              this.dialogRef.close(true);
              this.sweetAlertService.showSuccess('', 'Product imported successfully !!');
            },
            (error) => {
             
              this.dialogRef.close(true);
              this.sweetAlertService.showError('', 'Failed to import product !!');
            }
          );

        } else {
          this.fileType = file.type;
          this.invalidFileType = true;
          return;
        }
      }
    }

  
    removeFile(): void {
      this.fileName = '';
      const fileInput = document.querySelector('#fileInput') as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
    
    }

    // downloadCSVFile () {
    //   const blob = new Blob([this.convertToCSV(this.sampleData)], { type: 'text/csv' });
    //   saveAs(blob, 'products.csv');
    // }

    // downloadUserFile() {
    //   const blob = new Blob([this.convertToCSV(this.usersData)], { type: 'text/csv' });
    //   saveAs(blob, 'users_data.csv');
    // }



    downloadTemplate() {

      const product_details_data = [
        ['Product Name', 'Product SKU', 'Category Name', 'Release Date', 'Description', 'Tags', 'Sold Till Now', 'Video', 'Images'],
        ['Sample Product 1', '', 'cat1', '', '', '', '', '', 'Images1'],
        ['Sample Product 2', '', 'cat2', '', '', '', '', '', 'Images2'],
        ['Sample Product 3', '', 'cat3', '', '', '', '', '', 'Images3'],
        ['Sample Product 4', '', 'cat4', '', '', '', '', '', 'Images4'],
        ['Sample Product 5', '', 'cat5', '', '', '', '', '', 'Images5'],
      ];
    
      const specifications = [
        ['Product Name', 'Specification Name', 'From Value', 'To Value(Optional)', 'Unit'],
        ['Electronics', 'Weight', '', '', ''],
        ['Home Appliances', 'Power', '', '', ''],
        ['Furniture', 'Height', '', '', ''],
        ['Sports Equipment', 'Length', '', '', ''],
        ['Books', 'Pages', '', '', '']
      ];
    
      const getColumnWidths = (data: any[][]) => {
        const colWidths: { wch: number }[] = [];
        const numCols = Math.max(...data.map(row => row.length));
        for (let col = 0; col < numCols; col++) {
          let maxLen = 10;
          data.forEach(row => {
            const cell = row[col];
            if (cell) {
              maxLen = Math.max(maxLen, String(cell).length);
            }
          });
          colWidths.push({ wch: maxLen + 2 });
        }
        return colWidths;
      };
    
      const productSheet = XLSX.utils.aoa_to_sheet(product_details_data);
      productSheet['!cols'] = getColumnWidths(product_details_data);
    
      const specSheet = XLSX.utils.aoa_to_sheet(specifications);
      specSheet['!cols'] = getColumnWidths(specifications);
    
      const workbook: XLSX.WorkBook = {
        Sheets: {
          'Product Details': productSheet,
          'Specifications': specSheet
        },
        SheetNames: ['Product Details', 'Specifications']
      };
    
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = URL.createObjectURL(blob);
    
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'product_template.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    
    }
        

    convertToCSV(data: any[]): string {
      if (!data.length) {
        return '';
      }
  
      const header = Object.keys(data[0]).join(',');
      const rows = data.map(item => Object.values(item).join(','));
      return `${header}\n${rows.join('\n')}`;
    }

    // usersData: any [] = [
    //   {
    //     'ACCESS_TOKEN': localStorage.getItem('accessToken'),
    //     'USER_ID': localStorage.getItem('userId'),
    //     'OEM_ID': localStorage.getItem('oemId')
    //   }
    // ];

    // sampleData : any [] = [ 
    //   {
    //     "category": "524368c7-e03f-4f5f-9806-909d57b15f1b",
    //     "name": "Test-1",
    //     "productSku": "Test SKU CSV1",
    //     "releaseDate": "30-08-2024",
    //     "tags": "Tag1",
    //     "certificates": "Certificate1",
    //     "soldTillNow": "100",
    //     "description": "test description"
    //   },
    //   {
    //     "category": "524368c7-e03f-4f5f-9806-909d57b15f1b",
    //     "name": "Test-2",
    //     "productSku": "Test SKU CSV2",
    //     "releaseDate": "30-08-2024",
    //     "tags": "Tag1",
    //     "certificates": "Certificate1",
    //     "soldTillNow": "100",
    //     "description": "test description"
    //   },
    //   {
    //     "category": "524368c7-e03f-4f5f-9806-909d57b15f1b",
    //     "name": "Test-3",
    //     "productSku": "Test CSV1",
    //     "releaseDate": "30-08-2024",
    //     "tags": "Tag1",
    //     "certificates": "Certificate1",
    //     "soldTillNow": "100",
    //     "description": "test description"
    //   },
    //   {
    //     "category": "524368c7-e03f-4f5f-9806-909d57b15f1b",
    //     "name": "Test-4",
    //     "productSku": "Test CSV2",
    //     "releaseDate": "30-08-2024",
    //     "tags": "Tag1",
    //     "certificates": "Certificate1",
    //     "soldTillNow": "100",
    //      "description": "test description"
    //   }
    // ]

  //   downloadCategoryCSVFile() {
     
  //     const header = "id,name\n";
  
  //     const rows = this.categories.map(item => `${item.id},${item.name}`).join('\n');
  
  //     const blob = new Blob([header + rows], { type: 'text/csv' });
  
     
  //     saveAs(blob, 'categories.csv');
  // }
  

    getChildCategories() {
      this.categoryService.getLastNodeCategory().subscribe((data) => {
        this.categories = data.data;
      });
    }
}
